import React from 'react';
import { Hero } from './Hero';
import { PolicyContent } from './PolicyContent';
export function PrivacyPolicy() {
  return <div className="min-h-screen bg-background" data-id="element-413">
      <Hero data-id="element-414" />
      <PolicyContent data-id="element-415" />
    </div>;
}